module.exports = __webpack_public_path__ + "img/cl.cb56880f.png";